import React from 'react';
import ActionBar from './ActionBar';
import AddImageAction from './Actions/AddImageAction';
import { ImageListType } from 'react-images-uploading';
import ShareProviderAction from './Actions/ShareProviderAction/ShareProviderAction';
import IProvider from 'models/Providers/IProvider';

interface IProps {
    setImages: (imageList: never[]) => void;
    images: ImageListType;
    setProvider: (x: IProvider) => void;
}

export default function CreationActionBar({ setImages, images, setProvider }: IProps) {
    //hello developer. When you finally add a non template action, go ahead and delete this
    const on = true;
    //unless you do your own shenanigans, make the return component an ActionButton component
    const actions = [
        <AddImageAction setImages={setImages} images={images} />,
        <ShareProviderAction setProvider={setProvider} />,
    ];

    return on ? <ActionBar actions={actions} /> : <></>;
}
